import { primary } from "@/styles/variable"
import styled from "styled-components"

export const SeparatorContainer = styled.div`
  width: 100%;
  background-color: ${primary.black};
`
export const SeparatorLine = styled.div`
  width: 2px;
  height: 2px;
  transform: rotate(-90deg);
`
